// Fallback photos for gallery rows that don't have a photo_url set in the
// Gallery sheet tab (i.e. the original photos already bundled with the
// site). Keyed by photo_key, a stable id stored in the sheet's photo_key
// column. New rows added later won't have a matching key here, so they
// need a real photo_url — see galleryPhotos fallback logic in Gallery.js.
import gallery1 from './gallery/gallery1.jpg';
import gallery2 from './gallery/gallery2.jpg';
import gallery3 from './gallery/gallery3.jpg';
import gallery4 from './gallery/gallery4.jpg';
import gallery5 from './gallery/gallery5.jpg';
import gallery6 from './gallery/gallery6.jpg';
import boye1 from './gallery/Boye (1).jpg';
import boye2 from './gallery/Boye (2).jpg';
import boye3 from './gallery/Boye (3).jpg';
import boye4 from './gallery/Boye (4).jpg';
import boye5 from './gallery/Boye (5).jpg';

export const GALLERY_PHOTO_FALLBACKS = {
  boye1, boye2, boye3, boye4, boye5,
  gallery1, gallery2, gallery3, gallery4, gallery5, gallery6,
};
